import React, { useState } from 'react';

function DynamicLabelInput({
  labelText,
  type,
  name,
  id,
  autoComplete,
  value,
  onChange,
  disabled,
  // Optional handler the parent runs when the user leaves the field.
  onBlur,
  // When true, marks the input as invalid for assistive technology.
  ariaInvalid,
  // Id of the element holding this field's error message.
  ariaDescribedBy,
}) {
  const [isFocused, setIsFocused] = useState(false);
  const isActive = isFocused || value !== '';

  return (
    <div className="form-group _field-wrapper">
      <label
        className={`text-label ${isActive ? "active" : ""}`.trim()}
        htmlFor={id}
      >
        {labelText}
      </label>
      <input
        className="form-control"
        type={type}
        id={id}
        autoComplete={autoComplete}
        name={name}
        value={value}
        onChange={onChange}
        onFocus={() => setIsFocused(true)}
        // Resets the floating label's focus state, then calls the parent's onBlur if one was passed.
        onBlur={(event) => {
          setIsFocused(false);
          if (onBlur) {
            onBlur(event);
          }
        }}
        disabled={disabled}
        // Adds aria-invalid="true" only while the field is invalid.
        aria-invalid={ariaInvalid ? "true" : undefined}
        // Points screen readers to the field's error message.
        aria-describedby={ariaDescribedBy}
        // Removes the site's extra 2px red ring while invalid, leaving just the red border.
        style={ariaInvalid ? { boxShadow: "none" } : undefined}
        pattern={type === "tel" ? "[0-9]{3}-[0-9]{3}-[0-9]{4}" : null}
      />
    </div>
  );
}

export default DynamicLabelInput;

